import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import nextIcon from "../../assets/next icon.svg";
import backIcon from "../../assets/previous icon.svg";
import skipIntro from "../../assets/skip intro.svg";
import "./styles.css";
import "../../design/layout.css";



import { overView, setIntroSteps, setLogin, setStep } from "../../reduxStore/actions/action";
import QuestionAnswersModal from "./questionAnswersModal";

function Intro({ assets, setIntroSteps, introSteps, setLogin, setStep, overView, cards, gameAssets, utilAssets }) {
  console.log("assests11", utilAssets?.nextIcon);
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [choiceIndex, setChoiceIndex] = useState(null);

  const MagnusIntro1 = () => {
    return (
      <div className="intro-parent r-c-sa" style={{}}>
        <div className="intro-img-div" style={{}}>
          <img
            className=""
            src={assets[introSteps]}
            alt="Intro Image"
            style={{ objectFit: "contain", width: "100%", height: "100%" }}
          />
          {introSteps == 12 &&
            <div className="r-c-c-c parent-cards">
              {cards.map((card, index) => (
                <div
                  key={index}
                  className={`card-${index + 1} cursor-pointer`}
                  onClick={() => {
                    setChoiceIndex(index);
                    setIsOpenModal(true);
                  }}

                >
                  <img className='full-img' src={card} />
                </div>
              ))}
            </div>
          }

        </div>

      </div>
    );
  };




  console.log("checkimg", introSteps, assets[introSteps])
  return (
    <>
      <MagnusIntro1 />

      {introSteps == 16 ? null :
        <div className="parent-btn-img-1">
          <div className="parent-btns-1">
            <img
              className={`full-img-1 cursor-pointer`}
              style={{ cursor: introSteps > 0 ? 'pointer' : 'not-allowed' }}
              onClick={() => {
                if (introSteps > 0) setIntroSteps(introSteps - 1);
              }}
              src={utilAssets?.prevIcon}
            />
            <img
              className={`full-img-1 cursor-pointer ${introSteps < assets.length - 1 && introSteps !== 13 ? 'glow-blink' : ''}`}
              onClick={() => {
                if (introSteps < assets.length - 1 && introSteps !== 15) {
                  console.log('check10');
                  setIntroSteps(introSteps + 1);
                } else if (introSteps === 15) {
                  console.log('check14');
                  overView(
                    (e) => {
                      if (e === -2 || e === -3) {
                        setStep(-1);
                      } else {
                        setStep(e);
                      }
                    },
                    () => {
                      setStep(-1);
                    }
                  );
                }
              }}
              src={utilAssets?.nextIcon}
            />
          </div>
          <div
            className="parent-skip-1 cursor-pointer"
            onClick={() => overView((e) => {
              if (e === -2 || e === -3) {
                setStep(-1);
              } else {
                setStep(e);
              }
            }, () => { })}
          >
            <img className="full-img-2" src={utilAssets?.skipImg} />
          </div>
        </div>

      }
      {isOpenModal &&
        <QuestionAnswersModal
          isOpenModal={isOpenModal}
          setIsOpenModal={setIsOpenModal}
          choiceIndex={choiceIndex}
          gameAssets={gameAssets}
        />}
    </>
  );
}

const mapStateToProps = (state) => {
  const { assets, introSteps, cards, gameAssets, utilAssets } = state.SeTu;
  return { assets, introSteps, cards, gameAssets, utilAssets };
};

const mapDispatchToProps = (dispatch) => ({
  setIntroSteps: (val) => dispatch(setIntroSteps(val)),
  setLogin: (val) => dispatch(setLogin(val)),
  setStep: (val) => dispatch(setStep(val)),
  overView: (successCallBack, callBack) => dispatch(overView(successCallBack, callBack)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Intro);
